/**
 * Version Badge Module
 * 
 * Displays version information from CRD metadata.
 * Falls back to extracting version from first H1 heading if metadata not available.
 */

import { getCurrentMeta } from './files.js';

let badgeContainer = null;

/**
 * Initialize the version badge module
 * Gets reference to the badge container element
 */
export function initVersionBadge() {
  badgeContainer = document.getElementById('versionBadge');
  if (!badgeContainer) {
    console.warn('Version badge container not found');
  }
}

/**
 * Update the version badge based on CRD metadata
 * Falls back to extracting from first H1 if metadata not available
 */
export function updateVersionBadge() {
  if (!badgeContainer) return;
  
  // Try to get version from CRD metadata first
  const meta = getCurrentMeta();
  if (meta && meta.version) {
    // Display full version from metadata (e.g., "v0.1.0")
    const version = meta.version.startsWith('v') ? meta.version : 'v' + meta.version;
    badgeContainer.textContent = version.toLowerCase();
    badgeContainer.style.display = '';
    return;
  }
  
  // Fallback: Find the first H1 element in the ProseMirror editor
  const proseMirrorEl = document.querySelector('.ProseMirror');
  if (!proseMirrorEl) {
    clearVersionBadge();
    return;
  }
  
  const h1Element = proseMirrorEl.querySelector('h1');
  if (!h1Element) {
    clearVersionBadge();
    return;
  }
  
  // Extract version from heading text using regex
  const headingText = h1Element.textContent.trim();
  const versionMatch = headingText.match(/v(\d+\.\d+(?:\.\d+)?)/i);
  
  if (versionMatch) {
    // Version found - display it
    const version = versionMatch[0]; // e.g., "v0.1" or "v0.1.0"
    badgeContainer.textContent = version.toLowerCase(); // normalize to lowercase
    badgeContainer.style.display = 'block';
  } else {
    // No version found - hide badge
    clearVersionBadge();
  }
}

/**
 * Clear and hide the version badge
 */
export function clearVersionBadge() {
  if (!badgeContainer) return;
  
  badgeContainer.textContent = '';
  badgeContainer.style.display = 'none';
}
